import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'videoTimeIsInRange',
  standalone: true,
})
export class VideoTimeIsInRangePipe implements PipeTransform {
  transform(
    value: number | [number, number],
    currentSecond: number,
    durationSeconds: number,
    durationFrames: number
  ): boolean {
    const currentTimePercent = currentSecond / durationSeconds;

    if (Array.isArray(value)) {
      const [start, end] = value;
      return currentTimePercent >= start && currentTimePercent <= end;
    }

    const scaledValue = value * durationSeconds;
    const frameRate = durationFrames / durationSeconds;
    const delta = 1 / frameRate;
    return Math.abs(currentSecond - scaledValue) < delta;
  }
}
